import { render, staticRenderFns } from "./EventPersonalSlashie.vue?vue&type=template&id=f876939c&scoped=true&"
import script from "./EventPersonalSlashie.vue?vue&type=script&lang=js&"
export * from "./EventPersonalSlashie.vue?vue&type=script&lang=js&"
import style0 from "./EventPersonalSlashie.vue?vue&type=style&index=0&id=f876939c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f876939c",
  null
  
)

export default component.exports